import posthog, { isPosthogInitialized } from "@/app/infra/posthog"
import { sendGAEvent } from "@next/third-parties/google"

export type ProductEventName =
  | "nft_purchase_completed"
  | "nft_listing_created"
  | "nft_offer_created"
  | "nft_mint_completed"
  | "coinflow_checkout_completed"
  | "gacha_purchase_completed"
  | "gacha_buyback_completed"
  | "gacha_nft_sent"

export type ProductEventProperties = Record<
  string,
  string | number | boolean | null | undefined
>

function isGoogleAnalyticsReady() {
  // `GoogleAnalytics` (see `infra/google-analytics.tsx`) only renders when
  // GA_ID is set; it creates `window.dataLayer` before any event can fire.
  return typeof window !== "undefined" && "dataLayer" in window
}

/**
 * Sends a product event to every configured analytics sink.
 * Today that is PostHog and Google Analytics 4; both receive the same name
 * and properties so funnels line up across tools.
 */
export function trackProductEvent(
  name: ProductEventName,
  properties: ProductEventProperties = {},
) {
  if (isPosthogInitialized) {
    posthog.capture(name, properties)
  }
  if (isGoogleAnalyticsReady()) {
    sendGAEvent("event", name, properties)
  }
}
